import { base_colorAction } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_size_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  iframe {
    border: none;
  }

  .BaseModal-Body {
    padding: ${spacing(15)};
  }

  .corner-photo {
    position: absolute;
    top: 0;
    right: 0;
    border-top-right-radius: 10px;
  }

  .CardDisplayBox {
    margin-bottom: ${spacing(5)};
  }

  .card-section-header {
    color: gray;
  }

  .section-acknowledge {
    margin-top: ${spacing(5)};
  }

  .button-container {
    width: 100%;
  }

  .chevron {
    g,
    path {
      fill: gray;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .Button.no-shell {
    box-shadow: none;
  }

  .legal-text {
    font-size: ${font_size_md};
    line-height: 20px;

    ul {
      padding-left: ${spacing(5)};
    }
  }

  .additional-info-link {
    font-size: 14px;
  }

  .confirm-button {
    padding: ${spacing(5)} ${spacing(7)};
  }

  .error-link {
    color: ${base_colorAction};
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
`
